import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function dateLifeHistoryDocument30DaysOfVigency(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    const { value } = control;

    if (value === null) {
      return {
        description: '',
        code: '300',
      };
    }

    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    const currentDateAsNumber = <unknown>currentDate as number;
    const emitDateAsNumber = <unknown>value as number;
    const thirtyDays = 1000 * 3600 * 24;

    if ((currentDateAsNumber - emitDateAsNumber) / thirtyDays >= 30) {
      return {
        description: 'La fecha de emisión debe ser menor a 30  días',
        code: '300',
      };
    }
    return null;
  };
}
